<!-- @file 数据导出中心入口 -->
<template>
  <plv-tooltip
    content="数据导出中心"
  >
    <div class="c-header-bar__portal__container">
      <plv-popper
        popper-class-name="c-header-bar__portal-tip__container"
        :visible="popperVisible"
        trigger="custom"
        placement="bottom"
        @after-leave="handleAfterLeave"
      >
        <div
          v-if="tipShow"
          class="c-header-bar__portal-tip"
        >
          <div class="c-header-bar__portal-tip__title">数据导出中心</div>
          <div class="c-header-bar__portal-tip__desc">可以在这里查看你的导出记录</div>
          <div class="c-header-bar__portal-tip__button">
            <plv-button value="我知道了" @click="closePortalTip" />
          </div>
        </div>

        <div
          v-if="buildTipShow"
          class="c-header-bar__portal-tip c-header-bar__portal-tip-build"
        >
          <div class="c-header-bar__portal-tip__desc">“{{ fileName }}” 生成成功</div>
          <div class="c-header-bar__portal-tip__button">
            <plv-button
              :value="`下载到本地（${ countdownTime }s）`"
              @click="downloadData"
            />
          </div>
        </div>

        <div slot="reference" class="c-header-bar__portal-icon__container" @click="showDataExportCenter">
          <plv-icon
            class="c-header-bar__portal-icon plv-ml-8 p-export-icons"
            icon="data"
          />
          <plv-icon v-if="currentStatus === 0 || currentStatus === -1" icon="download-circle" class="c-header-bar__download-icon" />
          <plv-icon v-if="currentStatus === 1" icon="done-circle-fill" class="c-header-bar__done-icon" />
          <plv-icon v-if="currentStatus === 2" icon="warning-circle-fill" class="c-header-bar__warning-icon" />
        </div>
      </plv-popper>
    </div>
  </plv-tooltip>
</template>

<script>
import { mapState } from 'vuex';
import { dataExportMixin } from '@/mixins/data-export';

export default {
  mixins: [dataExportMixin],

  data() {
    return {
      popperVisible: false,
      tipShow: false, // 控制首次引导提示
      buildTipShow: false, // 控制生成成功提示
      viewStyle: {
        right: 0
      },
      currentStatus: '',
      countdownTime: 5,
      startTime: new Date().getTime(),
      downloadUrl: '',
      fileName: ''
    };
  },

  computed: {
    ...mapState({
      firstBootTipVisible: state => state.dataExport.firstBootTipVisible,
      isNeedPoll: state => state.dataExport.isNeedPoll
    }),
  },

  watch: {
    buildTipShow(val) {
      val && this.countDown();
      if (val) {
        this.$nextTick(() => {
          this.popperVisible = true;
        });
      } else {
        this.popperVisible = false;
      }
    },
    tipShow(val) {
      if (val) {
        this.$nextTick(() => {
          this.popperVisible = true;
        });
      } else {
        this.popperVisible = false;
      }
    },
    isNeedPoll(val) {
      val && this.getExportMessage();
    },
    firstBootTipVisible(val) {
      if (val) {
        this.tipShow = true;
      }
    }
  },

  mounted() {
    this.getExportMessage();
  },

  methods: {
    handleAfterLeave() {
      this.tipShow = false;
      this.buildTipShow = false;
    },
    closePortalTip() {
      this.popperVisible = false;
    },
    downloadData() {
      const urlArr = this.downloadUrl.split(':');
      window.open(`${location.protocol}${urlArr[1]}`, '_blank');
    },
    // 显示数据导出中心
    showDataExportCenter() {
      this.getExportList();
      this.$store.commit('dataExport/setDataExportCenterVisible', true);
    },
    setViewStyle() {
      const dom = document.querySelector('.c-header-bar__portal-icon__container');
      const { right: domRight } = dom.getBoundingClientRect();
      const right = document.body.clientWidth - domRight;
      this.viewStyle = {
        right: right + 'px'
      };
    },
    // 获取入口状态
    async getExportStatus() {
      const res = await this.$store.dispatch('dataExport/getExportStatus');
      // 0 代表正在生成，2 代表异常，1 代表处理成功
      this.currentStatus = res && res.status;
    },
    // 获取已完成的任务
    async getSuccessData() {
      const res = await this.$store.dispatch('dataExport/getSuccessData', {
        startTime: this.startTime
      });
      if (Array.isArray(res) && res.length !== 0) {
        // 获取最新已完成的任务
        this.downloadUrl = res[0].downloadUrl;
        this.fileName = res[0].filename;
        this.startTime = new Date().getTime();
        this.buildTipShow = true;
        // 更新数据导出中心的数据
        this.getExportList();
      }
    },
    // 定时调用接口，获取状态和已完成的任务
    async getExportMessage() {
      try {
        await this.getExportStatus();
        setTimeout(() => {
          this.getSuccessData();
        }, 15 * 1000);
      } finally {
        // 状态为“等待处理”或者“处理中”，继续轮询
        if (this.currentStatus === 0 || this.currentStatus === -1) {
          setTimeout(this.getExportMessage, 10 * 1000);
        }
      }
    },
    // 倒计时处理
    countDown() {
      const setTimeoutHandler = setTimeout(() => {
        this.countdownTime--;

        if (this.countdownTime === 0) {
          clearTimeout(setTimeoutHandler);
          this.buildTipShow = false;
          this.countdownTime = 5;
        } else {
          this.countDown();
        }

      }, 1000);
    }
  },
};
</script>

  <style lang="scss">
  .c-header-bar__portal-icon__container {
    position: relative;
    .plv-icon:not(.c-header-bar__portal-icon) {
      position: absolute;
      top: 13px;
      right: -2px;

      font-size: 10px;
    }
  }
  .c-header-bar__warning-icon {
    color: #ff5722;
  }
  .c-header-bar__done-icon,
  .c-header-bar__download-icon {
    color: #2196f3;
  }
  .c-header-bar__portal-tip__container {
    top: 48px !important;
  }
  .c-header-bar__portal-tip {
    box-sizing: border-box;
    padding: 14px 16px;
    width: 230px;
  }
  .c-header-bar__portal-tip__title {
    margin-bottom: 8px;

    font-size: 16px;
    font-weight: bold;
    line-height: 22px;

    color: #333;
  }
  .c-header-bar__portal-tip__desc {
    margin-bottom: 23px;

    font-size: 14px;
    line-height: 20px;

    color: #333;
  }
  .c-header-bar__portal-tip__button {
    text-align: center;
  }
  .c-header-bar__portal-tip-build {
    box-sizing: border-box;
    width: 256px;
  }

  .p-export-icons {
    font-size: 24px !important;
  }
  </style>
